import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { Dream, MyDreams, SparkCache, SparkCacheMetadata } from 'sparkello-core';
import { WebSpark } from '@/web';
import { SparkelloWebUser } from '@/web/model/user/SparkelloWebUser';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: localStorage,
  reducer: (state: any) => ({ sparkCacheInfo: state.sparkCacheInfo }),
});

const store = new Vuex.Store({
    state: {
      showNav: true,
      currentUser: null,
      userProfile: {} as SparkelloWebUser,
      myDreams: {
        orderedList: [],
        dreamOrder: [],
        index: new Map<string, Dream>(),
      } as MyDreams,
      sparks: [] as Array<WebSpark>,
      sparkCache: new SparkCache([]),
      sparkCacheInfo: new SparkCacheMetadata(),
    },
    actions: {
      logout(context) {
        context.commit('setCurrentUser');
        context.commit('setUserProfile');
        context.commit('setMyDreamsList');
        context.commit('setSparkCache', new SparkCache([]));
        context.commit('setSparkCacheInfo', new SparkCacheMetadata());
      },
    },
    mutations: {
      setShowNav(state, val) {
        state.showNav = val;
      },
      setMyDreamsList(state, val) {
        state.myDreams = val;
      },
      setCurrentUser(state, val) {
        state.currentUser = val;
      },
      setUserProfile(state, val) {
        state.userProfile = val;
      },
      setSparks(state, val) {
        state.sparks = val;
      },
      setSparkCache(state, val) {
        state.sparkCache = val;
      },
      setSparkCacheInfo(state, val) {
        state.sparkCacheInfo = val;
      },
    },
    plugins: [vuexLocal.plugin],
  },
);

export default store;
